<template>
    <div>
        <div class="header">
            <strong v-text="`手工充值仓余额：${balance/100}金豆`"></strong>
            <div class="block">
                <el-input v-model="value" type="number" placeholder="请输入"/>
                <el-button type="primary" @click="clickFunc(1)">增加</el-button>
                <el-button type="primary" @click="clickFunc(-1)">减少</el-button>
                <el-button type="primary" @click="clickFunc(0)">修改为</el-button>
            </div>
        </div>
        <div class="common-header">
            <h3>历史记录</h3>
            <div class="common-header-right">
                <div class="common-header-block">
                    <el-date-picker
                            v-model="date"
                            type="daterange"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd HH:mm"
                            range-separator="-"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期" @change="getList()"/>
                </div>
            </div>
        </div>
        <div class="common-table">
            <el-table v-loading="loading" :data="manualRechargeList.beanList" height="100%" row-key="id">
                <el-table-column type="index" label="编号" align="center"/>
                <el-table-column label="修改类型" align="center">
                    <template slot-scope="scope">
                        {{scope.row.type | typeName}}
                    </template>
                </el-table-column>
                <el-table-column label="修改前金豆数量" align="center" prop="beforeChips">
                <template slot-scope="scope">
                  {{scope.row.beforeChips/100}}
                </template>
                </el-table-column>
                <el-table-column label="修改数量" align="center" prop="changeChip">
                  <template slot-scope="scope">
                    {{scope.row.changeChip/100}}
                  </template>
                </el-table-column>
                <el-table-column label="修改后金豆数量" align="center" prop="afterChips">
                  <template slot-scope="scope">
                    {{scope.row.afterChips/100}}
                  </template>
                </el-table-column>
                <el-table-column label="操作账号" align="center" prop="operatorUsername"/>
                <el-table-column label="操作时间" width="150" align="center" prop="createdTime"/>
            </el-table>
        </div>
        <el-pagination
                class="common-el-pagination"
                layout="prev,pager,next,jumper"
                background
                :page-size="20"
                :pager-count="5"
                :total="manualRechargeList.total"
                :current-page="currentPage"
                @current-change="getList($event)"/>
        <div v-if="show" class="common-popup-bg">
            <div class="common-popup">
                <h3>提示</h3>
                <table class="common-popup-table">
                    <tr>
                        <td style="text-align: center">
                            <template v-if="type === -1">是否确认减少{{value}}金豆到手工充值仓？</template>
                            <template v-if="type === 1">是否确认增加{{value}}金豆到手工充值仓？</template>
                            <template v-if="type === 0">是否确认将手工充值仓余额修改为{{value}}金豆？</template>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <el-input placeholder="请输入验证码" v-model="code" class="code"></el-input>
                            <btn-countdown @my-click="sendCodeToMyPhone({err:$event.err,type:10})"></btn-countdown>
                        </td>
                    </tr>
                </table>
                <footer>
                    <el-button size="small" @click="closePopup">取消</el-button>
                    <el-button size="small" type="primary" @click="updateChips">确定</el-button>
                </footer>
            </div>
        </div>
    </div>
</template>
<script>
    import {mapState, mapActions} from 'vuex'
    import btnCountdown from 'components/btnCountdown'

    export default {
        components: {
            btnCountdown,
        },
        data() {
            return {
                loading: false,
                show: false,// 修改金豆确认弹窗
                value: '',// 设置的金豆数
                type: '',// 增加 减少 设置为
                code: '',// 短信验证码
                date: '',
                currentPage: 1,
            }
        },
        computed: {
            ...mapState('manualRecharge', ['balance', 'manualRechargeList'])
        },
        created() {
            this.getBalance();
            this.getList();
        },
        filters: {
            typeName(op) {
                switch (op) {
                    case 21:
                        op = '增加';
                        break;
                    case 22:
                        op = '减少';
                        break;
                    case 20:
                        op = '修改为';
                        break;
                    default:
                        break;
                }
                return op;
            }
        },
        methods: {
            ...mapActions('manualRecharge', ['getBalance', 'getManualRechargeList', 'updateBalance']),
            ...mapActions('other', ['sendCodeToMyPhone']),
            getList(page = 1) {
                this.loading = true;
                this.currentPage = page;
                this.getManualRechargeList({
                    page,
                    startTime: this.date && this.date[0],
                    endTime: this.date && this.date[1],
                }).then(() => {
                    this.loading = false
                })
            },
            // 点击增加 减少 改变金豆数
            clickFunc(type) {
                if (!this.value) {
                    this.$message.info('请输入金豆数');
                    return
                }
                this.show = true;
                this.type = type;
            },
            updateChips() {
                if (!this.code) {
                    this.$message.error('请输入验证码');
                    return
                }
                this.updateBalance({
                    chip: this.value * 100,
                    smsCode: this.code,
                    op: this.type
                }).then(() => {
                    this.$message.success('修改成功');
                    this.closePopup();
                    this.getList(this.currentPage)
                })
            },
            closePopup() {
                this.value = '';
                this.code = '';
                this.show = false;
            }
        }
    }
</script>
<style lang="scss" scoped>
    .header {
        position: relative;
        padding-bottom: 20px;
        margin-bottom: 10px;
        line-height: 40px;
        border-bottom: 1px solid $border-color;
    }

    .block {
        display: inline-block;
        padding-left: 100px;
        :global(.el-input) {
            width: 240px;
            margin-right: 10px;
            vertical-align: middle;
        }
    }

    .code {
        width: 180px;
        margin-right: 10px;
    }
</style>